export class Locations {
  id: any;
  name: string;
  current_address?: String;
  latitude?: any;
  longitude?: any;
  zipcode?: string;
  state?: string;
  city?: string;
  street_address?: string;
  created_at: String;
  updated_at: String;
  location_collection_id?: any;
  full_address?: string;

  constructor() {
    const keys = ['id', 'created_at'];
    keys.forEach((key) => this[key] = null);
  }

  setData(locationData) {
    const data = locationData.location;
    Object.keys(data).map((item) => {
      this[item] = data[item];
    });
  }
}
